import { STACK_SIZES as e, STACK_DIRECTIONS as i, STACK_ALIGNMENTS as a, STACK_JUSTIFY_CONTENTS as l, STACK_SIZE_DEFAULT as n } from "./watson.es80.js";
import { openBlock as o, createElementBlock as r, normalizeClass as f, renderSlot as c } from "vue";
import "./watson.WStack.es2.js";
import p from "./watson.es37.js";
const u = {
  name: "WStack",
  props: {
    /**
     * The values in the gap are mapped to our semantic spacing tokens, which are small (for S), medium (for M), large (for L), and xlarge (for XL).
     * @values none, small, medium, large, xlarge
     * @default none
     * */
    gap: {
      type: String,
      default: "none",
      validator: (t) => e.includes(t)
    },
    /**
     * It defines whether the flex items are forced in a single line or can be flowed into multiple lines. If set to multiple lines, it also defines the cross-axis which determines the direction new lines are stacked in. Values are false (default) and true for multiline items.
     * @values false, true
     * @default false
     * */
    wrap: {
      type: Boolean,
      default: !1
    },
    /**
     * Direction of the stack items.
     * @values row, column, row-reverse, column-reverse
     * @default row
     * */
    direction: {
      type: String,
      default: "row",
      validator: (t) => i.includes(t)
    },
    /**
     * Sets the vertical alignment and distribution of the stack items.
     * @values flex-start, flex-end, center, baseline, stretch
     * @default flex-start
     * */
    alignItems: {
      type: String,
      default: "flex-start",
      validator: (t) => a.includes(t)
    },
    /**
     * Sets the horizontal alignment and distribution of the stack items.
     * @values flex-start, flex-end, center, space-between
     * @default flex-start
     * */
    justifyContent: {
      type: String,
      default: "flex-start",
      validator: (t) => l.includes(t)
    },
    /**
     * Expands the stack to occupy all available widths.
     * @values false, true
     * @default false
     * */
    fullWidth: {
      type: Boolean,
      default: !1
    },
    /**
     * Expands the stack to occupy all available height.
     * @values false, true
     * @default false
     * */
    fullHeight: {
      type: Boolean,
      default: !1
    }
  },
  computed: {
    stackClassOptions() {
      const t = ["w-stack"];
      return this.wrap && t.push("w-stack-wrap"), this.gap !== n && t.push(`w-stack-gap-${this.gap}`), this.direction && t.push(`w-stack-direction-${this.direction}`), this.alignItems && t.push(`w-stack-align-items-${this.alignItems}`), this.justifyContent && t.push(`w-stack-justify-content-${this.justifyContent}`), this.fullWidth && t.push("w-stack-full-width"), this.fullHeight && t.push("w-stack-full-height"), t;
    }
  }
};
function d(t, h, S, m, g, s) {
  return o(), r("div", {
    class: f(s.stackClassOptions)
  }, [
    c(t.$slots, "default")
  ], 2);
}
const y = /* @__PURE__ */ p(u, [["render", d]]);
export {
  y as default
};
